<template>
    <b-dropdown :text="`${prefix}${getText(value)}`" toggle-class="caret" v-bind="$attrs" right v-on="$listeners">
        <template v-for="item in items">
            <b-dropdown-item :key="`key-${item}`" :active="item === value" @click="$emit('input', item)">{{ getText(item) }}</b-dropdown-item>
        </template>
    </b-dropdown>
</template>



<script>
    export default {
        name: 'DropdownFilter',
        props: {
            value: {
                type: [String, Number, Boolean],
                default: null,
                validator: val => val === null || val === true || val === false || typeof val === 'string' || typeof val === 'number',
            },
            items: {
                type: Array,
                required: true,
            },
            prefix: {
                type: String,
                default: '',
            },
        },
        methods: {
            getText(value) {
                return this.$tx(`filterItem.${value}`, value);
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "filterItem": {
        "amount": "Suma sprzedaży",
        "quantity": "Liczba [sztuk]",
        "impressions": "Wyświetlenia ofert",
        "clicks": "Kliknięcia",
        "summary": "Suma",
        "percentDiff": "Zmiana %",
        "averageDesc": "Średnia % malejąco",
        "averageAsc": "Średnia % rosnąco",
        "changeDesc": "Zmiana % (do poprzedniego zakresu) malejąco",
        "changeAsc": "Zmiana % (do poprzedniego zakresu) rosnąco",
        "10": "10",
        "20": "20",
        "50": "50",
        "null": "Wszystkie",
        "day": "Dzienny",
        "month": "Miesięczny",
        "quarter": "Kwartalny",
        "year": "Roczny"
    }
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "filterItem": {
        "amount": "Sum of sales",
        "quantity": "Number [pieces]",
        "impressions": "Offers display",
        "clicks": "Clicks",
        "summary": "Total",
        "percentDiff": "Change %",
        "averageDesc": "Average % descending",
        "averageAsc": "Average % ascending",
        "changeDesc": "Change % (to previous range) descending",
        "changeAsc": "Change % (to previous range) ascending",
        "10": "10",
        "20": "20",
        "50": "50",
        "null": "All",
        "day": "Daily",
        "month": "Monthly",
        "quarter": "Quarterly",
        "year": "Annual"
    }
}
</i18n>

